import React from 'react';

import { DIFFICULTY, DIFFICULTY_COLORS } from '../../../const/difficulty';

// A colour-coded bar down the left edge of a song row standing in for the
// difficulty label (see DIFFICULTY_COLORS - cool to hot). It's a flex item that
// stretches to the row's full height. Clicking it opens the difficulty filter
// modal so you can filter from here; the name rides along as a hover tooltip /
// a11y label.
const DifficultyBar = ({ difficulty, onClick }: DifficultyBarTypes) => (
	<button
		aria-label={`Filter by difficulty (this song: ${difficulty})`}
		onClick={onClick}
		style={{
			...barStyle,
			backgroundColor: DIFFICULTY_COLORS[difficulty],
		}}
		title={difficulty}
		type="button"
	/>
);

const barStyle: React.CSSProperties = {
	alignSelf: 'stretch',
	border: 'none',
	borderRadius: 0,
	cursor: 'pointer',
	flexShrink: 0,
	padding: 0,
	width: 15,
};

type DifficultyBarTypes = {
	difficulty: DIFFICULTY;
	onClick: () => void;
};

export default DifficultyBar;
